import { Evidence } from '@/api/holeInOneClaim/evidence.types.ts';

export const HoleInOneClaimStatuses = {
  PENDING_EVIDENCE: 'pendingEvidence',
  EXPIRED: 'expired',
  SUBMITTED: 'submitted',
  APPROVED: 'approved',
  REJECTED: 'rejected',
} as const;

export type HoleInOneClaimStatus =
  (typeof HoleInOneClaimStatuses)[keyof typeof HoleInOneClaimStatuses];

export type HoleInOneClaimBasicData = {
  id: string;
  golfRoundId: string;
  happenedAtUnix: number;
  latitude: string;
  longitude: string;
  holeNumber: number;
  insuranceProvider?: string;
  insuranceClaimNumber?: string;
  status: HoleInOneClaimStatus;
  submittedAtUnix?: number;
  createdAt: string;
  updatedAt: string;
};

export type HoleInOneClaim = {
  id: string;
  status: HoleInOneClaimStatus;
  submittedBy: string;
  submittedAtUnix?: number;
};

export type HoleInOneClaimDetails = {
  id: string;
  status: HoleInOneClaimStatus;
  submittedBy: string;
  golfCourseName: string;
  happenedAtUnix: number;
  latitude: string;
  longitude: string;
  holeNumber: number;
  rewardTierName: string;
  golfRoundId: string;
  roundStartedAtUnix: number;
  insuranceClaimNumber?: string;
  insuranceProvider?: string;
  claimWitnesses: string[];
  claimEvidence: Evidence[];
};

export type UpdateHoleInOneClaimStatusData = {
  status: HoleInOneClaimStatus;
};
